exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Pmain-content {\r\n    padding-top: 0px !important;\r\n    margin-right: auto !important;\r\n    margin-left: auto !important;\r\n    padding-left: 1px !important;\r\n    padding-right: 0px !important;\r\n    position: relative;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden !important;\r\n    padding-bottom: 0 !important;\r\n    scrollbar-color: #00688F #f5f5f5 !important;\r\n    scrollbar-width: thin !important;\r\n    top: -11px;\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    min-height: 200px;\r\n    height: 571px;\r\n}\r\n\r\n.menuselected {\r\n    float: left;\r\n    background-color: #e8e6e6;\r\n}\r\n\r\n\r\n/* .menuselected li {\r\n    color: white !important;\r\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/Parent-Portal/parentformconatiner/parentformconatiner.component.css
// module id = 1104
// module chunks = 322